<template>
  <div class="recently">
    <div
      v-if="recentlyPlayedFinal.length"
      class="is-flex ion-justify-content-between ion-align-items-center"
    >
      <h1 class="fz-24">{{ $t('home.continueListening') }}</h1>

      <ion-button
        fill="clear"
        color="light"
        class="fz-12 fw-300"
        @click="$router.push('/continue-watching')"
        >{{ $t('home.recently') }}</ion-button
      >
    </div>

    <div class="recently-wrap">
      <swiper
        :slides-per-view="'auto'"
        :space-between="10"
        :free-mode="true"
        :key="sliderKey"
        :modules="swiperModules"
      >
        <swiper-slide v-for="data in recentlyPlayedFinal" :key="data.id">
          <RecentlySinglePodcast
            :podcast-data="data"
            :key="`${data.id}-card`"
          />
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { FreeMode } from 'swiper/modules';
import { IonButton } from '@ionic/vue';
import RecentlySinglePodcast from '@/components/common/RecentlySinglePodcast.vue';
import { useStore } from 'vuex';
import { computed, ref, watch } from 'vue';
import useRecentlyPlayed from '@/composables/useRecentlyPlayed';

import 'swiper/css';
import 'swiper/css/free-mode';

export default {
  name: 'RecentlyPlayedSlider',
  components: {
    Swiper,
    SwiperSlide,
    RecentlySinglePodcast,
    IonButton,
  },
  props: {
    selectedCategory: {
      type: [String, Number],
      default: 'all',
    },
  },

  setup(props) {
    const { getNotCompletedPodcasts } = useRecentlyPlayed();
    const store = useStore();
    const sliderKey = ref(Math.random());
    const swiperModules = [FreeMode];
    const recentlyPlayedData = computed(
      () => store.state.recentlyPlayed.recentlyPlayedDetails,
    );

    const sortedRecentlyData = computed(() => [...recentlyPlayedData.value]);

    const recentlyPlayedFinal = computed(() => {
      const combined = [
        ...sortedRecentlyData.value,
        ...store.state.player.recentlyPlayed,
      ].filter(getNotCompletedPodcasts);

      // Remove duplicates by id
      const seen = new Set();
      const commonArray = combined.filter((item) => {
        if (seen.has(item.id)) return false;
        seen.add(item.id);
        return true;
      });

      commonArray.sort(
        (a, b) => b.progress_updated_timestamp - a.progress_updated_timestamp,
      );

      if (props.selectedCategory !== 'all') {
        return commonArray.filter(
          (item) => item.category_id === props.selectedCategory,
        );
      }

      return commonArray;
    });

    watch(
      () => recentlyPlayedFinal.value,
      () => {
        sliderKey.value = Math.random();
      },
    );

    return {
      recentlyPlayedData,
      sortedRecentlyData,
      recentlyPlayedFinal,
      sliderKey,
      swiperModules,
    };
  },
};
</script>

<style scoped lang="scss">
@use '@/theme/custom' as *;

.recently-wrap {
  .swiper-slide {
    text-align: left;
    max-width: 310px !important;
    margin: 0px 16px 0px 0px;
  }
  @media (max-width: $tablet-breakpoint) {
    .swiper-slide {
      max-width: 240px !important;
    }
  }
}
</style>
